// React imports
import React from 'react';
import classnames from 'classnames';
import { Provider } from 'react-redux';

// UI Imports
import {
  AmplifyCore,
  caseUtils,
  commonEnums,
  activity,
  loadStates,
  objectUtils
} from '@codametrix/ui-common';
import {
  Card,
  LoadingSlugs,
  MiniTabs,
  Modal,
  UniversalFeedback
} from '@codametrix/ui-components';

// Components imports
import SpinnerTag from '../../assets/spinner/spinner.svg';
import VitalWareModal from './code-bench.vw-modal';

import { BillingGroup } from '../billing-group/billing-group';
import { CodeBenchPanel } from '../code-bench-panel/code-bench-panel';
import { CaseDetail } from '../case-detail/case-detail';
import { CodeBenchActionBar } from '../code-bench-action-bar/code-bench-action-bar';
import { ProcessStatus } from '../process-status/process-status';
import { ChargeCounts } from '../code-bench-panel/charge-counts/charge-counts';
import { Timeline } from '../timeline/timeline';
import { Confirm } from '../confirm/confirm';
import { ChargeSelector } from '../charge-selector/charge-selector';
import { Improvements } from '../improvements/improvements';
import { Icon } from '@codametrix/ui-components';
import { RelatedCases } from '../related-cases/related-cases';
import { StatusDescription } from '../case-status/case-status';
import { StandalonePageableList } from '../standalone-pageable-list/standalone-pageable-list';
import { CaseAlert } from '../case-alert/case-alert';
import { Conditional } from '@codametrix/ui-components';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
import './styles/index.scss';
enum TitleTabsEnum {
  CHANGES_TEXT = 'See changes to this case'
}

const { conditionalUtils } = AmplifyCore;

class CodeBench extends React.Component<Accelerate.CodeBenchPanelProps, any> {
  caseDetailRef: React.RefObject<CaseDetail>;
  iframeRef: React.RefObject<HTMLIFrameElement>;

  static defaultProps = {
    benchEditable: { ...AmplifyCore.state.DEFAULT_BENCH_EDITABLE },
    improvements: { ...AmplifyCore.state.improvements },
    capabilities: { ...AmplifyCore.state.capabilities },
    relatedCasesLoadState: { ...loadStates.LOAD_STATES.done },
    relatedCasesPageable: {
      ...AmplifyCore.paginationUtils.relatedCasesSortablePageable
    },
    processInstanceGuids: [],
    hostCaseId: null,
    loadAlwaysFromURL: false,
    propertyConfig: {
      patient: [],
      summary: [],
      expanded: []
    },
    confirm: {
      display: false,
      title: ''
    },
    activity: [],
    noteTypes: [],
    workItem: {
      assignee: '',
      owner: '',
      aging_days: '',
      codable_days: ''
    },
    onLoad: (caseRun: CMxAPI.CaseRun) => {},
    onChargeSessionAction: (
      transactionAction: CMxCommonApp.TransactionAction
    ) => {},
    onReload: (params: any) => {},
    onSearchClear: (codeQuery: Accelerate.CodeActionContextual) => {},
    onCodeSearch: (codeQuery: Accelerate.CodeQuery) => {},
    onCodeSearchSelection: (
      searchSelection: Accelerate.CodeAddActionPayload
    ) => {},
    handleAddAllCodes: (searchSelection: Accelerate.CodesAddCodeBench) => {},
    handleRemoveAllCodes: (codeChange: Accelerate.CodeChange) => {},
    onChargeSessionMetaEdit: (chargeSession: CMxCommonApp.ChargeSession) => {},
    onCodeUpdate: (changeDetail: Accelerate.CodeChange) => {},
    onCodeRemove: (changeDetail: Accelerate.CodeChange) => {},
    onTimeBasedCodeAdd: (time: string, age: string) => {},
    onTimeBasedCodeUpdate: (time: string, age: string) => {},
    onCodeSearchDrop: (changeDetail: Accelerate.CodeChange) => {},
    onTransactionSharedDiagnosisChange: (
      changeDetail: CMxCommonApp.TransactionSharedCodeChange
    ) => {},
    onPrompt: (action: string) => {},
    onPopUpClose: () => {},
    onFeatureActivation: (selection: CMxCommonApp.ChargeSessionSelection) => {},
    onNavigate: (caseId: string, replace?: boolean, serviceLine?: string) => {},
    hidevitalwareIssuesModal: () => {},
    onImprovementAdd: (
      documentImprovement: AmplifyAPI.DocumentImprovement
    ) => {},
    onImprovementUpdate: (
      documentImprovement: AmplifyAPI.DocumentImprovement
    ) => {},
    onImprovementRemove: (
      documentImprovement: AmplifyAPI.DocumentImprovement
    ) => {},
    onProviderAdd: (documentImprovement: AmplifyAPI.DocumentImprovement) => {},
    onProviderRemove: (
      documentImprovement: AmplifyAPI.DocumentImprovement
    ) => {},
    onProviderUpdate: (
      documentImprovement: AmplifyAPI.DocumentImprovement
    ) => {},
    onDocumentImprovementSearch: (codeQuery: CMxCommonApp.CodeQuery) => {},
    showAmplifyFeedback: (feedback: AmplifyAPI.AmplifyFeedback) => {},
    onProviderSearch: (query: CMxCommonApp.LookupQuery) => {},
    updateValue: (val: any) => {},
    updateCase: (idAndUpdates: any) => {},
    loadRoles: (roles: string[]) => {},
    getFlagItems: (activeItem: CMxAPI.CaseRunV2) => {},
    setActiveMiniTab: (activeTabName: string) => {},
    setUnresolvedDocuments: (value: boolean) => {},
    showCoderNotesInfo: (coderNotesParams: CMxCommonApp.CoderNotesParams) => {},
    searchResults: {},
    codeSearchResultsV2: {},
    displayAddCharge: false,
    showAddChargeError: false,
    showLoadingSubmission: false,
    showLoadingCancelation: false,
    showSizeExpWarning: false,
    showFeedBack: false,
    showSubmittedFeedback: false,
    showCanceledFeedback: false,
    submittedFeedbackTimer: false,
    showvitalwareIssuesModal: false,
    toggleHoldCaseModal: false,
    toggleExclusionCaseModal: false,
    showLateCaseClearModal: false,
    toggleSplitCaseModal: false,
    showCoderNotesModal: false,
    submitOldCaseModal: false,
    vitalwareIssues: [],
    mergeSplitHistoryIssues: [],
    caseAccessTime: '',
    activeMiniTab: commonEnums.MiniTabLabels.CHARGES_LABEL,
    showUnresolvedDocuments: false,
    relatedCaseFilterOptions: {},
    updateRelatedCasesFilterSelection: (
      options: CMxCommonApp.FilterSelection
    ) => {}
  };

  constructor(props: Accelerate.CodeBenchPanelProps) {
    super(props);
    this.onCodeUpdate = this.onCodeUpdate.bind(this);
    this.onCodeRemove = this.onCodeRemove.bind(this);
    this.onTimeBasedCodeAdd = this.onTimeBasedCodeAdd.bind(this);
    this.onTimeBasedCodeUpdate = this.onTimeBasedCodeUpdate.bind(this);
    this.onCodeSearchDrop = this.onCodeSearchDrop.bind(this);
    this.onCodeSearch = this.onCodeSearch.bind(this);
    this.onCodeSearchSelection = this.onCodeSearchSelection.bind(this);
    this.onFeatureSelection = this.onFeatureSelection.bind(this);
    this.handleGroupedCaseClick = this.handleGroupedCaseClick.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleInvoiceEdit = this.handleInvoiceEdit.bind(this);
    this.handlePromptDismiss = this.handlePromptDismiss.bind(this);
    this.handleMetaAction = this.handleMetaAction.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onModalAddChargeOpen = this.onModalAddChargeOpen.bind(this);
    this.onModalAddChargeClose = this.onModalAddChargeClose.bind(this);
    this.handleAddCharge = this.handleAddCharge.bind(this);
    this.handleTimer = this.handleTimer.bind(this);
    this.handleInvoiceAddition = this.handleInvoiceAddition.bind(this);
    this.handleTransactionSharedDiagnosisChange =
      this.handleTransactionSharedDiagnosisChange.bind(this);
    this.handleDeleteSizeExpWarning =
      this.handleDeleteSizeExpWarning.bind(this);
    this.handleEnableTechPro = this.handleEnableTechPro.bind(this);
    this.handleDisableTechPro = this.handleDisableTechPro.bind(this);

    this.caseDetailRef = React.createRef();
    this.iframeRef = React.createRef();

    const codeUpdateDebounced = this.onCodeUpdate.bind(this);
    this.onCodeUpdate = objectUtils.debounce(codeUpdateDebounced, 500);
    this.handleHARCaseList = this.handleHARCaseList.bind(this);
    this.onMiniTabSelection = this.onMiniTabSelection.bind(this);
  }

  componentDidUpdate(
    prevProps: Readonly<Accelerate.CodeBenchPanelProps>,
    prevState: Readonly<any>,
    snapshot?: any
  ): void {
    if (!this.props.loadAlwaysFromURL) return;
    if (prevProps.match?.url !== this.props.match?.url) {
      this.props.match.params.getCaserunWithRefresh =
        conditionalUtils.capabilityValue(
          this.props?.capabilities?.capabilities?.getCaseRunWithRefresh?.on ??
            false
        );
      this.props.onLoadFromURLMatch(this.props.match);

      const case_uid = this.props.match?.params?.caseId;
      const caserun_uid = this.props.match?.params?.id;
      this.props.loadWorkItemDetails(case_uid, caserun_uid);
      // Loads cursorAPIContext from connected props(from dashboard-ui) to capabilities state(shared-views)
      this.props.loadServicedeskContext(this.props.cursorAPIContext);
    }
  }

  componentDidMount() {
    this.props.loadRoles(this.props.roles);
    const hasActiveItem = !objectUtils.isEmpty(this.props.activeItem);

    let case_uid = '',
      caserun_uid = '';

    if (this.props.loadAlwaysFromURL || !hasActiveItem) {
      this.props.match.params.getCaserunWithRefresh =
        conditionalUtils.capabilityValue(
          this.props?.capabilities?.capabilities?.getCaseRunWithRefresh?.on ??
            false
        );
      this.props.onLoadFromURLMatch(this.props.match);
      case_uid = this.props.match?.params?.caseId;
      caserun_uid = this.props.match?.params?.id;
    } else {
      this.props.onLoad(this.props.activeItem);
      case_uid = this.props.activeItem.case_uid;
      caserun_uid = this.props.activeItem.caserun_uid;
    }

    this.props.loadWorkItemDetails(case_uid, caserun_uid);

    // Loads cursorAPIContext from connected props(from dashboard-ui) to capabilities state(shared-views)
    this.props.loadServicedeskContext(this.props.cursorAPIContext);
  }

  handleCancel(event: React.MouseEvent) {
    event.preventDefault();
    this.props.onInvoicesCancel(this.props.processInstance);
  }

  handleSubmit(
    event: React.MouseEvent,
    vwComment: string = null,
    submitWithOverrideButton: boolean = false,
    remove_hold: boolean = null
  ) {
    event.preventDefault();
    const cursorAPIPayload: CMxCommonApp.CursorAPIPayload = {
      operation: commonEnums.CursorOperation.NEXT,
      cursorAPIContext: this.props.cursorAPIContext
    };

    this.props.onInvoicesSubmisson({
      processInstance: this.props.processInstance,
      uiMode: this.props.UIMode,
      vwComment,
      submitWithOverrideButton,
      cursorAPIPayload,
      activeItem: this.props.activeItem as CMxAPI.CaseRunV2,
      removeHold: remove_hold
    });
  }

  handlePreviousClick(event: React.MouseEvent) {
    event.preventDefault();
    const { processInstanceGuids, activeItem } = this.props;

    const loc = processInstanceGuids.findIndex(
      (item) => item === activeItem.process_instance_guid
    );
    this.props.handleTraversal(processInstanceGuids[loc - 1]);
  }

  handleModalClose(ev: React.MouseEvent) {
    ev.preventDefault();
    this.props.onPopUpClose();
  }

  handlePromptDismiss(ev: React.MouseEvent) {
    ev.preventDefault();
    this.props.onPrompt('REFRESH_TOKEN');
  }

  handleConfirm(actionItem: Accelerate.ActionItem) {
    this.props.onPopUpClose();
  }

  handleConfirmDismiss(actionItem: Accelerate.ActionItem) {
    this.props.onPopUpClose();
  }

  handleInvoiceEdit(invoice: CMxCommonApp.CodableInvoice) {
    this.props.onInvoiceEdit(invoice, this.props.processInstance);
  }

  handleInvoiceAddition(invoices: CMxCommonApp.CodableInvoice[]) {
    this.props.onInvoiceAddition(
      (invoices && invoices.length > 0
        ? invoices[0]
        : null) as CMxCommonApp.CodableInvoice | null,
      this.props.processInstance
    );
  }

  handleMetaAction(transactionAction: CMxCommonApp.TransactionAction) {
    const invoice = this.props.codableInvoices.find(
      (invoice) => invoice.guid === transactionAction.meta.invoice.guid
    );
    this.props.onChargeSessionAction({
      ...transactionAction,
      meta: {
        ...transactionAction.meta,
        invoice: invoice,
        processInstance: this.props.processInstance
      }
    });
  }

  handleGroupedCaseClick(ev: React.MouseEvent) {
    ev.preventDefault();
    const target =
      (ev.target as HTMLDivElement) || document.createElement('div');
    const linkable = target?.closest('a');
    if (!linkable) return;

    const item = linkable.attributes.getNamedItem('data-case-id');
    if (!item) return;

    const caseId = item.value;
    if (!caseId) return;

    const hostCaseId = this.props.hostCaseId
      ? this.props.hostCaseId
      : this.props.activeItem.case_id;

    const replace = hostCaseId !== this.props.activeItem.case_id;

    this.props.onPopUpNavigate({
      caseId: item.value,
      replace,
      serviceLine: this.props.activeItem.service_line,
      hostCaseId
    });
  }

  onFeatureSelection(selection: CMxCommonApp.ChargeSessionSelection) {
    this.props.onFeatureActivation(selection);
    this.caseDetailRef.current.onFeatureActivation(selection);
  }
  // The CodeQuery, SearchResult, and CodeChange all rely on a common
  // property called context.  This is what will allow business
  // logic upstream to have standard patterns for figuring out what to do
  // with various actions.

  onCodeSearch(commonCodeQuery: CMxCommonApp.CodeQuery) {
    const context = {
      ...commonCodeQuery.context,
      activeItem: { ...this.props.activeItem },
      userContext: { ...this.props.userContext }
    };
    const codeQuery = { ...commonCodeQuery, context };
    const isMod = codeQuery.searchType === commonEnums.CodeType.MODIFIER;
    if (isMod) {
      codeQuery.text = `${codeQuery.text}`.toUpperCase();
    }
    //
    if (codeQuery.text.length > 2 || (codeQuery.text.length === 2 && isMod)) {
      this.props.onCodeSearch(codeQuery);
    } else {
      this.props.onSearchClear(
        codeQuery,
        commonCodeQuery.searchResultsLookupKey
      );
    }
  }

  onCodeSearchSelection(commonSearchResult: Accelerate.CodeActionPayload) {
    if (objectUtils.isEmpty(commonSearchResult)) {
      return;
    }
    const defaultPrevented =
      commonSearchResult.context?.defaultPrevented ?? false;

    if (defaultPrevented) {
      this.props.onSearchClear({
        context: {
          ...commonSearchResult.context,
          activeItem: this.props.activeItem
        }
      });
    } else {
      const context = {
        ...commonSearchResult.context,
        activeItem: { ...this.props.activeItem },
        invoices: [...this.props.codableInvoices]
      };
      const searchResult: Accelerate.CodeAddActionPayload = {
        codeInfo: commonSearchResult.codeInfo,
        context
      };
      this.props.onCodeSearchSelection(searchResult);
    }
  }

  onCodeUpdate(commonChangeDetail: CMxCommonApp.CodeChange) {
    const context = {
      ...commonChangeDetail.context,
      activeItem: { ...this.props.activeItem },
      invoices: [...this.props.codableInvoices]
    };
    const changeDetail = { ...commonChangeDetail, context };

    this.props.onCodeUpdate(changeDetail);
  }

  onCodeRemove(commonChangeDetail: CMxCommonApp.CodeChange) {
    const context = {
      ...commonChangeDetail.context,
      activeItem: { ...this.props.activeItem },
      invoices: [...this.props.codableInvoices]
    };
    const changeDetail = { ...commonChangeDetail, context };
    this.props.onCodeRemove(changeDetail);
  }

  onTimeBasedCodeAdd(
    commonChangeDetail: CMxCommonApp.CodeChange,
    time: string,
    age: string
  ) {
    const context = {
      ...commonChangeDetail.context,
      activeItem: { ...this.props.activeItem },
      invoices: [...this.props.codableInvoices]
    };
    const codeChange = { ...commonChangeDetail, context };
    this.props.onTimeBasedCodeAdd(codeChange, time, age);
  }
  onTimeBasedCodeUpdate(
    commonChangeDetail: CMxCommonApp.CodeChange,
    time: string,
    age: string
  ) {
    const context = {
      ...commonChangeDetail.context,
      activeItem: { ...this.props.activeItem },
      invoices: [...this.props.codableInvoices]
    };
    const codeChange = { ...commonChangeDetail, context };
    this.props.onTimeBasedCodeUpdate(codeChange, time, age);
  }
  onCodeSearchDrop(commonChangeDetail: CMxCommonApp.CodeChange) {
    const context = {
      ...commonChangeDetail.context,
      activeItem: { ...this.props.activeItem },
      invoices: [...this.props.codableInvoices]
    };
    const changeDetail = { ...commonChangeDetail, context };
    this.props.onCodeSearchDrop(changeDetail);
  }

  handleTransactionSharedDiagnosisChange(
    changeDetail: CMxCommonApp.TransactionSharedCodeChange
  ) {
    this.props.onTransactionSharedDiagnosisChange(changeDetail);
  }

  handleHARCaseList(options?: CMxCommonApp.SortablePageable<any>) {
    this.props.getCasesWithEncounter({
      encounterId: this.props.activeItem?.encounter_identifier?.number,
      sortablePageable: options,
      serviceLine: this.props.activeItem?.service_line,
      filterSelection: this.props.relatedCasesFilterSelection
    });
  }

  /**
   * Event that happen when click add charge button
   * @returns {void}
   */
  onModalAddChargeOpen() {
    this.props.onModalAddChargeOpen();
  }

  /**
   * Event that happen when moda of add charge button is closed
   * @returns {void}
   */
  onModalAddChargeClose(e) {
    this.props.onModalAddChargeClose(e);
  }

  /**
   * Event launched when invoice is clicked
   */
  handleAddCharge(invoice: AmplifyAPI.Invoice) {
    if (invoice.deleted) {
      this.handleInvoiceAddition([invoice] as CMxCommonApp.CodableInvoice[]);
    } else {
      this.props.handleAddCharge({
        invoiceGuid: invoice.guid,
        processInstanceId: this.props.processInstance.guid.uuid,
        activeItem: this.props.activeItem
      });
    }
  }

  /**
   * Method that is called for decrement timer
   */
  handleTimer() {
    this.props.handleTimer();
  }

  /**
   * Method that is called when user wants to close the modal for size experience warning
   */
  handleDeleteSizeExpWarning() {
    this.props.deleteSizeExpWarning();
  }

  /**
   * Method used for enable a procedure with tech/pro charge
   * @param context
   */
  handleEnableTechPro(
    techCodableTransaction: CMxCommonApp.TechCodableTransaction
  ) {
    techCodableTransaction.processInstance = this.props.processInstance;
    this.props.handleEnableTechPro(techCodableTransaction);
  }

  /**
   * Method used for disable a procedure with tech/pro charge
   * @param context
   */
  handleDisableTechPro(
    techCodableTransaction: CMxCommonApp.TechCodableTransaction
  ) {
    techCodableTransaction.processInstance = this.props.processInstance;
    this.props.handleDisableTechPro(techCodableTransaction);
  }

  onMiniTabSelection(selection: CMxCommonApp.MiniTab) {
    this.props.setActiveMiniTab(selection.displayName);
  }

  onRelatedCasesFilterApply = (filters: CMxCommonApp.FilterSelection) => {
    this.props.updateRelatedCasesFilterSelection(filters);
    this.props.getCasesWithEncounter({
      encounterId: this.props.activeItem?.encounter_identifier?.number,
      sortablePageable: {
        ...AmplifyCore.paginationUtils.relatedCasesSortablePageable
      },
      serviceLine: this.props.activeItem?.service_line,
      filterSelection: filters
    });
  };

  render() {
    const {
      nonCodeBench,
      chargeSessions,
      counts,
      searchResults,
      benchEditable,
      processInstance,
      activations,
      groupedCases,
      modalURL,
      hostCaseId,
      onChargeSessionAction,
      activity,
      prompt,
      confirm,
      showSubmittedFeedback,
      showLoadingSubmission,
      showLoadingCancelation,
      showSizeExpWarning,
      showCanceledFeedback,
      submittedFeedbackTimer,
      showvitalwareIssuesModal,
      toggleHoldCaseModal,
      toggleExclusionCaseModal,
      showLateCaseClearModal,
      toggleSplitCaseModal,
      vitalwareIssues,
      mergeSplitHistoryIssues,
      documentImprovementIssues,
      holdIssues,
      hidevitalwareIssuesModal,
      displayAddCharge,
      showAddChargeError,
      showAddChargeLoading,
      loadState,
      codableInvoices,
      feedback,
      showFeedBack,
      UIMode,
      epicToken,
      codeEdits,
      invoiceOptions,
      caseEdits,
      showHoldCaseModal,
      hideHoldCaseModal,
      showExclusionCaseModal,
      hideExclusionCaseModal,
      toggleChargeableCase,
      toggleLateCaseClearModal,
      clearLateCaseNotification,
      holdCase,
      improvements,
      capabilities,
      updateValue,
      updateCase,
      relatedCases,
      relatedCasesPageable,
      flagList,
      htmlNotes,
      customClaimsRelatedCases,
      customClaimsRelatedCasesLoadState,
      workItem,
      ...caseDetailProps
    } = this.props;

    const flagListSet: string[] = Array.from(
      new Set(flagList?.map((flag) => flag?.flag))
    );
    const actionBar = <CodeBenchActionBar {...this.props} />;

    let codeEditingPanel;
    let button, relatedCasesView;

    let isActive = !caseUtils.isFinishedCase(caseDetailProps.activeItem);

    if (showSubmittedFeedback || showCanceledFeedback) {
      if (submittedFeedbackTimer) {
        window.parent.postMessage(
          {
            action: 'Epic.Clinical.Informatics.Web.CloseActivity',
            token: epicToken
          },
          '*'
        );
      } else {
        this.handleTimer();
      }
    }

    const showProcessStatus = !benchEditable.editable;
    const showModal = modalURL !== null && modalURL.path;
    const modalURI = showModal ? modalURL.path + modalURL.queryString : '';
    const benchLoading = loadState.loading;
    const invoices = invoiceOptions?.invoices ?? [];

    const styles = classnames([
      'code-bench',
      {
        'bench-pre-editable': benchEditable.waiting,
        'bench-cancelled': benchEditable.cancelled,
        'bench-loading': benchLoading
      }
    ]);

    if (benchEditable.waiting) {
      codeEditingPanel = <ProcessStatus benchEditable={benchEditable} />;
    } else {
      const noCodableInvoices =
        codableInvoices === null || codableInvoices.length === 0;

      const innerBench =
        (noCodableInvoices && codableInvoices === null) || loadState.loading ? (
          <LoadingSlugs key="loading-slugs" numberItems={3} />
        ) : (
          [
            noCodableInvoices ? (
              <div>
                <div className="no-charges empty-message">
                  No charges found.
                </div>
              </div>
            ) : (
              <CodeBenchPanel
                key="code-bench-panel"
                panelActivations={activations.panel}
                onChargeSessionAction={this.handleMetaAction}
                onFeatureSelection={this.onFeatureSelection}
                editable={benchEditable.editable}
                benchEditable={benchEditable}
                caseDetailProps={caseDetailProps}
                searchResults={searchResults}
                benchLoading={benchLoading}
                codeEdits={codeEdits}
                onInvoiceMetaEdit={this.handleInvoiceEdit}
                onCodeSearchSelection={this.onCodeSearchSelection}
                onCodeSearch={this.onCodeSearch}
                onCodeUpdate={this.onCodeUpdate}
                onCodeRemove={this.onCodeRemove}
                onTimeBasedCodeAdd={this.onTimeBasedCodeAdd}
                onTimeBasedCodeUpdate={this.onTimeBasedCodeUpdate}
                onCodeSearchDrop={this.onCodeSearchDrop}
                onTransactionSharedDiagnosisChange={
                  this.handleTransactionSharedDiagnosisChange
                }
                counts={counts}
                processInstance={processInstance}
                codableInvoices={codableInvoices}
                showProcessStatus={showProcessStatus}
                handleEnableTechPro={this.handleEnableTechPro}
                handleDisableTechPro={this.handleDisableTechPro}
                customClaimsRelatedCases={this.props.customClaimsRelatedCases}
                customClaimsRelatedCasesLoadState={
                  this.props.customClaimsRelatedCasesLoadState
                }
                openChildWindow={this.props.openChildWindow}
              />
            ),
            <div>
              {benchEditable.editable && (
                <div
                  key="add-charge-button"
                  className="add-charge-div"
                  onClick={this.onModalAddChargeOpen}>
                  <BiomeIcon
                    iconName={IconName.Plus}
                    titleText="Add Charge"
                    iconSize="16"
                    iconClass="plus-icon"
                  />
                  <a className="add-charge-btn">Add Charge</a>
                </div>
              )}
            </div>,
            <div key="charge-totals" className="summary-section">
              <h5>Summary</h5>
              <ChargeCounts counts={counts} />
            </div>
          ]
        );

      const improvementsCapability = conditionalUtils.capabilityValue(
        capabilities.capabilities.improvements.on
      );
      if (AmplifyCore.isIPCServiceline(this.props.activeItem.service_line)) {
        relatedCasesView = (
          <>
            <a
              className="patient-info-link"
              href={'#/patient-info'}
              onClick={(ev) => {
                ev.preventDefault();
                this.props.showPatientInfo(
                  this.props.activeItem as CMxAPI.CaseRunV2
                );
              }}>
              View more patient info
            </a>

            <StandalonePageableList
              list={this.handleHARCaseList}
              sortablePageable={relatedCasesPageable}
              theme={'cmx-theme'}>
              <RelatedCases
                relatedCases={relatedCases}
                showLoading={
                  benchLoading || caseDetailProps.relatedCasesLoadState.loading
                }
                activeItem={this.props.activeItem}
                onOpenRelatedCase={this.props.openChildWindow}
                showProviderInfo={this.props.showProviderInfo}
                filterData={this.props.filterData}
                relatedCasesFilterSelection={
                  this.props.relatedCasesFilterSelection
                }
                onRelatedCasesFilterApply={this.onRelatedCasesFilterApply}
                relatedCasesFilterCapability={
                  capabilities.capabilities.relatedCasesFilter
                }
              />
            </StandalonePageableList>
          </>
        );
      } else {
        relatedCasesView = (
          <>
            {benchLoading || caseDetailProps.billingGroupLoadState.loading ? (
              <LoadingSlugs key="loading-slugs" numberItems={1} />
            ) : (
              <div
                className="status-section"
                onClick={this.handleGroupedCaseClick}>
                <BillingGroup
                  suppressedLinks={[hostCaseId]}
                  showProcessStatus={true}
                  isActive={isActive}
                  cancelled={benchEditable.cancelled}
                  groupedCases={groupedCases}
                  showLoading={caseDetailProps.billingGroupLoadState.loading}
                  viewOnly={!benchEditable.editable}
                />
              </div>
            )}
          </>
        );
      }

      const miniTabsItems = [
        {
          id: 'charges',
          displayName: commonEnums.MiniTabLabels.CHARGES_LABEL,
          active:
            this.props.activeMiniTab ===
            commonEnums.MiniTabLabels.CHARGES_LABEL,
          body: innerBench,
          icon: (
            <BiomeIcon
              iconName={IconName.Coding}
              iconSize="18"
              iconClass="tab-icon"
              titleText={commonEnums.MiniTabLabels.CHARGES_DESCRIPTION}
            />
          ),
          titleText: commonEnums.MiniTabLabels.CHARGES_DESCRIPTION
        },
        {
          id: 'relatedCases',
          displayName: commonEnums.MiniTabLabels.RELATED_LABEL,
          active:
            this.props.activeMiniTab ===
            commonEnums.MiniTabLabels.RELATED_LABEL,
          body: relatedCasesView,
          icon: (
            <BiomeIcon
              iconName={IconName.Related}
              iconSize="18"
              iconClass="tab-icon"
              titleText={commonEnums.MiniTabLabels.RELATED_DESCRIPTION}
            />
          ),
          titleText: commonEnums.MiniTabLabels.RELATED_DESCRIPTION
        },
        {
          id: 'activity',
          displayName: commonEnums.MiniTabLabels.ACTIVITY_LABEL,
          active:
            this.props.activeMiniTab ===
            commonEnums.MiniTabLabels.ACTIVITY_LABEL,
          body: <Timeline items={activity} />,

          icon: (
            <BiomeIcon
              iconName={IconName.History}
              iconSize="18"
              iconClass="tab-icon"
              titleText={commonEnums.MiniTabLabels.ACTIVITY_DESCRIPTION}
            />
          ),
          titleText: commonEnums.MiniTabLabels.ACTIVITY_DESCRIPTION
        },
        improvementsCapability && {
          id: 'improvements',
          displayName: commonEnums.MiniTabLabels.IMPROVEMENTS_LABEL,
          active:
            this.props.activeMiniTab ===
            commonEnums.MiniTabLabels.IMPROVEMENTS_LABEL,
          body: (
            <Improvements
              {...this.props}
              improvementsAction={capabilities.capabilities.improvementsAction}
              showUnresolved={this.props.showUnresolvedDocuments}
            />
          ),
          icon: (
            <BiomeIcon
              iconName={IconName.Reports}
              iconSize="18"
              iconClass="tab-icon"
              titleText={commonEnums.MiniTabLabels.IMPROVEMENTS_DESCRIPTION}
            />
          ),
          titleText: commonEnums.MiniTabLabels.IMPROVEMENTS_DESCRIPTION
        }
      ].filter(Boolean);

      codeEditingPanel = [
        <Card key="charge-sessions" className="cmx-card-panel">
          <div className="status-area">
            {benchLoading ? (
              <LoadingSlugs key="loading-slugs" numberItems={1} />
            ) : (
              <div className="status-section case-status-section">
                <StatusDescription
                  secondaryPrefix="Review Required"
                  includeBox={true}
                  caseRun={caseDetailProps.activeItem}
                />
                <Conditional every={[flagListSet?.length > 0]}>
                  <div
                    className={`flex-section ${
                      caseUtils.getStatusReason(caseDetailProps.activeItem)
                        ? 'zeroTopPadding'
                        : ''
                    }`}>
                    {flagListSet.map((flag, index) => (
                      <div className="flag-item-box" key={`flag-${index}`}>
                        <p className="flag-item" title={flag}>
                          {flag}
                        </p>
                      </div>
                    ))}
                  </div>
                </Conditional>
              </div>
            )}
          </div>

          <div className="charge-sessions">
            <MiniTabs
              items={miniTabsItems}
              onSelection={this.onMiniTabSelection}
            />
          </div>
        </Card>,
        <>
          {UIMode === commonEnums.UIModesEnum.EPIC_EMBEDDED ? (
            <div className="debug-box">
              <a className="debug-link" href="/debug">
                Debug
              </a>
            </div>
          ) : (
            ''
          )}
        </>
      ];
    }

    return (
      <div className={styles}>
        {prompt && (
          <div className="top-level-modal">
            <Modal
              title={prompt.text}
              closable={false}
              onSubmit={this.handlePromptDismiss}
              buttonText="Yes"
              maximize={false}>
              <p>
                Click <b>Yes</b> below to stay logged in.
              </p>
            </Modal>
          </div>
        )}
        <Confirm
          onConfirm={this.props.handleConfirm}
          onDismiss={this.props.handleConfirmDismiss}
          {...confirm}
        />
        {showModal && (
          <Modal onClose={this.handleModalClose} maximize={true}>
            <iframe
              ref={this.iframeRef}
              src={modalURI}
              className="popup-frame"
            />
          </Modal>
        )}
        {(showSubmittedFeedback || showCanceledFeedback) && (
          <div className="qa-submitted-modal">
            <UniversalFeedback
              feedback={{
                message: `Successfully ${
                  showSubmittedFeedback ? 'submitted' : 'canceled'
                }`,
                id: new Date().getTime(),
                dismissable: true
              }}
              showingTime={3000}
              dismissFeedback={this.props.hideSubmittedFeedback}
              showFeedback={showSubmittedFeedback || showCanceledFeedback}
            />
          </div>
        )}
        {(showLoadingSubmission || showLoadingCancelation) && (
          <div className="qa-submitted-modal">
            <UniversalFeedback
              feedback={{
                message: `${
                  showLoadingSubmission ? 'Submitting...' : 'Canceling...'
                }`,
                id: new Date().getTime(),
                dismissable: false,
                meta: { level: commonEnums.FeedbackMeta.WARNING }
              }}
              showFeedback={showLoadingSubmission || showLoadingCancelation}
            />
          </div>
        )}
        {displayAddCharge && (
          <Modal
            onClose={this.onModalAddChargeClose}
            title={
              showAddChargeLoading ? 'Adding charge' : 'Add a charge for:'
            }>
            <div className="qa-add-charge-modal">
              {!showAddChargeLoading ? (
                <ChargeSelector
                  handleAddCharge={this.handleAddCharge}
                  handleInvoiceAddition={this.handleInvoiceAddition}
                  invoiceOptions={
                    invoiceOptions as any as AmplifyAPI.InvoiceOptionsDTO
                  }
                />
              ) : (
                <div className="spinner-box">
                  <img src={SpinnerTag} alt="in progress" className="spinner" />
                </div>
              )}

              <div className="charge-error-box">
                {showAddChargeError ? (
                  <small className="charge-error-text">
                    Error adding a new charge
                  </small>
                ) : (
                  ''
                )}
              </div>
            </div>
          </Modal>
        )}
        <CaseDetail
          ref={this.caseDetailRef}
          mode="code-edit"
          codeEdits={codeEdits}
          codeEditingPanel={codeEditingPanel}
          groupedCases={groupedCases}
          {...caseDetailProps}
          loadState={loadState}
          activations={activations}
          actionBar={actionBar}
          updateValue={updateValue}
          updateCase={updateCase}
          showAttachDocsModal={this.props.showAttachDocsModal}
          capability={capabilities.capabilities.caseEdit}
          coderNotesCapability={capabilities.capabilities.coderNotes}
          capabilities={capabilities}
          processInstance={this.props.processInstance}
          caseEdits={caseEdits}
          noteUnavailableReason={
            capabilities.capabilities.noteUnavailableReason
          }
          UIMode={this.props.UIMode}
          showCoderNotesInfo={this.props.showCoderNotesInfo}
          workItem={workItem}
        />
        <UniversalFeedback
          feedback={feedback}
          dismissFeedback={this.props.hideFeedback}
          showFeedback={showFeedBack}
          showingTime={5000}
        />
        {showSizeExpWarning && (
          <div className="top-level-modal">
            <Modal
              title={'Help us improve your experience'}
              closable={true}
              onClose={this.handleDeleteSizeExpWarning}
              onSubmit={this.handleDeleteSizeExpWarning}
              buttonText="Dismiss"
              maximize={false}>
              <p>
                Consider adjusting the width of your browser to a wider setting
                for a better view of CMX Amplify.
              </p>
            </Modal>
          </div>
        )}
        {showvitalwareIssuesModal && (
          <VitalWareModal
            onClose={this.props.hidevitalwareIssuesModal}
            onSubmit={(event, comment, remove_hold) =>
              this.handleSubmit(event, comment, true, remove_hold)
            }
            vitalwareIssues={vitalwareIssues}
            mergeSplitHistoryIssues={mergeSplitHistoryIssues}
            documentImprovementIssues={documentImprovementIssues}
            holdIssues={holdIssues}
            holdCaseStatus={capabilities.holdCaseStatus}
            improvements={this.props.improvements?.improvements}
            setActiveMiniTab={this.props.setActiveMiniTab}
            setUnresolvedDocuments={this.props.setUnresolvedDocuments}
          />
        )}
      </div>
    );
  }
}

export { CodeBench };
